import axios from 'axios'

export const alert = (message: Object) => {
  axios.post('/api/alerts', {
    message,
    userAgent: window.navigator.userAgent,
  })
}
